module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-layout-for-world-map"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._t("main")], 2), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_vm._t("bottom")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fc1beb1e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/world-map-layout/index.vue
// module id = 246
// module chunks = 0